import { ArrowRight, Menu } from "lucide-react";

import { URLS } from "@/config/domains";

import { MarketingButton } from "./ui/MarketingButton";
import { MarketingContainer } from "./ui/MarketingContainer";

const navigation = [
  {
    label: "Features",
    href: "#features",
  },
  {
    label: "How It Works",
    href: "#how-it-works",
  },
  {
    label: "Pricing",
    href: "#pricing",
  },
  {
    label: "FAQ",
    href: "#faq",
  },
];

export function MarketingNavbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-slate-950/80 backdrop-blur-xl">
      <MarketingContainer className="flex h-20 items-center justify-between">
        <a
          href="/"
          className="flex items-center gap-3"
          aria-label="MinistryIQ home"
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-500 text-sm font-black text-white shadow-lg shadow-indigo-500/20">
            IQ
          </div>

          <div>
            <div className="text-lg font-bold tracking-tight text-white">
              Ministry
              <span className="text-indigo-400">
                IQ
              </span>
            </div>

            <div className="hidden text-[10px] font-medium uppercase tracking-[0.18em] text-slate-500 sm:block">
              See More. Care Better. Lead Smarter.
            </div>
          </div>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navigation.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-medium text-slate-400 transition hover:text-white"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 sm:flex">
          <MarketingButton
            href={`${URLS.church}/app/login`}
            variant="ghost"
          >
            Church Login
          </MarketingButton>

          <MarketingButton href="/request-access">
            Request Pilot Access
            <ArrowRight className="ml-2 h-4 w-4" />
          </MarketingButton>
        </div>

        <button
          type="button"
          className="rounded-lg p-2 text-slate-300 hover:bg-white/5 sm:hidden"
          aria-label="Open navigation"
        >
          <Menu className="h-6 w-6" />
        </button>
      </MarketingContainer>
    </header>
  );
}
